import { Feature } from "../../../components/FeatureList/FeatureList"
import useStrings from "../../../localization/useStrings"
import images from "../../../utils/images"
import svg from "../../../utils/svg"
import SimplePaywallStep from "../SimplePaywallStep/SimplePaywallStep"
import styles from "./LockPicturesPaywallStep.module.scss"

const LockPicturesPaywallStep = () => {
  const strings = useStrings().multistep

  return (
    <SimplePaywallStep>
      <div className={styles.container}>
        <label className={styles.title}>{strings.lockTitle}</label>
        <div className={styles.imageContainer}>
          <div
            className={`${images.multistep.lockImage.class} ${styles.image}`}
          />
          <FeatureList />
        </div>
      </div>
    </SimplePaywallStep>
  )
}

const FeatureList = () => {
  const strings = useStrings()

  const features: Feature[] = [
    {
      title: "Cloud Vault",
      inconSvg: svg.featureIcons.CloudVault,
      badge: strings.new,
    },
    {
      title: strings.decoy,
      inconSvg: svg.featureIcons.Decoy,
    },
    {
      title: strings.animated.breakinShort,
      inconSvg: svg.featureIcons.Breakin,
    },
    {
      title: strings.animated.unlimitedPhotos,
      inconSvg: svg.featureIcons.Star,
    },
    {
      title: strings.adFree,
      inconSvg: svg.featureIcons.Adfree,
    },
  ]

  return (
    <div className={styles.headerFeatureListContainer}>
      <div className={styles.headerFeatureList}>
        {features.map((feature, index) => (
          <div className={styles.featureContainer} key={index}>
            {<feature.inconSvg className={styles.icon} />}
            <label className={styles.featureTitle}>
              {feature.title.toUpperCase()}
            </label>
          </div>
        ))}
      </div>
    </div>
  )
}

export default LockPicturesPaywallStep
